import React from "react";
import { Redirect, Router } from "@reach/router";
import useAuth from "../services/auth/hooks/useAuth";
import Public from "../views/public/Public";
import { PUBLIC } from "./public";
import Private from "../views/private/Private";
import { PRIVATE } from "./private";

export const HOME = "/";

const Routes: React.FC = () => {
  const { user } = useAuth();

  return (
    <Router>
      <Redirect from={HOME} to={PUBLIC} noThrow default />
      <Public path={`${PUBLIC}/*`} />

      {user !== null && <Private path={`${PRIVATE}/*`} />}
    </Router>
  );
};

export default Routes;
